// Copyright 2020
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/service/v1/device_manager.proto (package msh.service.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { BoolValue, proto3, Timestamp } from "@bufbuild/protobuf";
import { Device, DeviceFilter } from "../../resource/v1/device_pb";
import { IOTCoreCommandStatus, Page, TimeFrame } from "../../common/v1/common_pb";
import { Command_DeviceCommand } from "./command_pb";
import { Event, EventFilter } from "../../resource/v1/event_pb";

/**
 * The parameters to AddDevice.
 *
 * @generated from message msh.service.v1.AddRequest
 */
export const AddRequest = proto3.makeMessageType(
  "msh.service.v1.AddRequest",
  () => [
    { no: 1, name: "serial_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "iot_device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "registry_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "cloud_location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "blocked", kind: "message", T: BoolValue },
  ],
);

/**
 * The parameters to DeleteDevice.
 * Either serial number or the iot_device_id
 *
 * @generated from message msh.service.v1.DeleteRequest
 */
export const DeleteRequest = proto3.makeMessageType(
  "msh.service.v1.DeleteRequest",
  () => [
    { no: 1, name: "serial_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "iot_device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * The parameters to UpdateDevice.
 *
 * @generated from message msh.service.v1.UpdateRequest
 */
export const UpdateRequest = proto3.makeMessageType(
  "msh.service.v1.UpdateRequest",
  () => [
    { no: 1, name: "serial_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "blocked", kind: "message", T: BoolValue },
  ],
);

/**
 * The parameters to UpdateDevice.
 *
 * @generated from message msh.service.v1.UpdateLabelRequest
 */
export const UpdateLabelRequest = proto3.makeMessageType(
  "msh.service.v1.UpdateLabelRequest",
  () => [
    { no: 1, name: "iot_device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.ProvisionRequest
 */
export const ProvisionRequest = proto3.makeMessageType(
  "msh.service.v1.ProvisionRequest",
  () => [
    { no: 1, name: "serial_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "public_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.ProvisionResponse
 */
export const ProvisionResponse = proto3.makeMessageType(
  "msh.service.v1.ProvisionResponse",
  () => [
    { no: 1, name: "device", kind: "message", T: Device },
  ],
);

/**
 * @generated from message msh.service.v1.ProvisionWithIdRequest
 */
export const ProvisionWithIdRequest = proto3.makeMessageType(
  "msh.service.v1.ProvisionWithIdRequest",
  () => [
    { no: 1, name: "iot_device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "public_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.ProvisionWithIdResponse
 */
export const ProvisionWithIdResponse = proto3.makeMessageType(
  "msh.service.v1.ProvisionWithIdResponse",
  () => [
    { no: 1, name: "device", kind: "message", T: Device },
  ],
);

/**
 * @generated from message msh.service.v1.ProvisionPodWithHubIdRequest
 */
export const ProvisionPodWithHubIdRequest = proto3.makeMessageType(
  "msh.service.v1.ProvisionPodWithHubIdRequest",
  () => [
    { no: 1, name: "iot_device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "public_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "hub_iot_device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.ProvisionPodWithHubIdResponse
 */
export const ProvisionPodWithHubIdResponse = proto3.makeMessageType(
  "msh.service.v1.ProvisionPodWithHubIdResponse",
  () => [
    { no: 1, name: "device", kind: "message", T: Device },
  ],
);

/**
 * @generated from message msh.service.v1.AdminProvisionRequest
 */
export const AdminProvisionRequest = proto3.makeMessageType(
  "msh.service.v1.AdminProvisionRequest",
  () => [
    { no: 1, name: "serial_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.AdminProvisionResponse
 */
export const AdminProvisionResponse = proto3.makeMessageType(
  "msh.service.v1.AdminProvisionResponse",
  () => [
    { no: 1, name: "device", kind: "message", T: Device },
  ],
);

/**
 * @generated from message msh.service.v1.UnProvisionRequest
 */
export const UnProvisionRequest = proto3.makeMessageType(
  "msh.service.v1.UnProvisionRequest",
  () => [
    { no: 1, name: "serial_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.UnProvisionResponse
 */
export const UnProvisionResponse = proto3.makeMessageType(
  "msh.service.v1.UnProvisionResponse",
  [],
);

/**
 * @generated from message msh.service.v1.AdminUnProvisionRequest
 */
export const AdminUnProvisionRequest = proto3.makeMessageType(
  "msh.service.v1.AdminUnProvisionRequest",
  () => [
    { no: 1, name: "serial_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.AdminUnProvisionResponse
 */
export const AdminUnProvisionResponse = proto3.makeMessageType(
  "msh.service.v1.AdminUnProvisionResponse",
  [],
);

/**
 * Result returned from AddDevice.
 *
 * @generated from message msh.service.v1.AddResponse
 */
export const AddResponse = proto3.makeMessageType(
  "msh.service.v1.AddResponse",
  [],
);

/**
 * Result returned from DeleteDevice.
 *
 * @generated from message msh.service.v1.DeleteResponse
 */
export const DeleteResponse = proto3.makeMessageType(
  "msh.service.v1.DeleteResponse",
  [],
);

/**
 * Result returned from UpdateDevice.
 *
 * @generated from message msh.service.v1.UpdateResponse
 */
export const UpdateResponse = proto3.makeMessageType(
  "msh.service.v1.UpdateResponse",
  [],
);

/**
 * Result returned from UpdateLabelDevice.
 *
 * @generated from message msh.service.v1.UpdateLabelResponse
 */
export const UpdateLabelResponse = proto3.makeMessageType(
  "msh.service.v1.UpdateLabelResponse",
  [],
);

/**
 * @generated from message msh.service.v1.GetRequest
 */
export const GetRequest = proto3.makeMessageType(
  "msh.service.v1.GetRequest",
  () => [
    { no: 1, name: "serial_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.GetResponse
 */
export const GetResponse = proto3.makeMessageType(
  "msh.service.v1.GetResponse",
  () => [
    { no: 1, name: "device", kind: "message", T: Device },
  ],
);

/**
 * @generated from message msh.service.v1.GetDeviceByIDRequest
 */
export const GetDeviceByIDRequest = proto3.makeMessageType(
  "msh.service.v1.GetDeviceByIDRequest",
  () => [
    { no: 1, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.GetDeviceByIDResponse
 */
export const GetDeviceByIDResponse = proto3.makeMessageType(
  "msh.service.v1.GetDeviceByIDResponse",
  () => [
    { no: 1, name: "device", kind: "message", T: Device },
  ],
);

/**
 * @generated from message msh.service.v1.ListRequest
 */
export const ListRequest = proto3.makeMessageType(
  "msh.service.v1.ListRequest",
  () => [
    { no: 1, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "message", T: Page },
    { no: 3, name: "filter", kind: "message", T: DeviceFilter },
  ],
);

/**
 * @generated from message msh.service.v1.ListResponse
 */
export const ListResponse = proto3.makeMessageType(
  "msh.service.v1.ListResponse",
  () => [
    { no: 1, name: "devices", kind: "message", T: Device, repeated: true },
    { no: 2, name: "page", kind: "message", T: Page },
  ],
);

/**
 * @generated from message msh.service.v1.SendDeviceCommandRequest
 */
export const SendDeviceCommandRequest = proto3.makeMessageType(
  "msh.service.v1.SendDeviceCommandRequest",
  () => [
    { no: 1, name: "serial_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "command", kind: "enum", T: proto3.getEnumType(Command_DeviceCommand) },
  ],
);

/**
 * @generated from message msh.service.v1.SendDeviceCommandResponse
 */
export const SendDeviceCommandResponse = proto3.makeMessageType(
  "msh.service.v1.SendDeviceCommandResponse",
  [],
);

/**
 * @generated from message msh.service.v1.SendRebootCommandRequest
 */
export const SendRebootCommandRequest = proto3.makeMessageType(
  "msh.service.v1.SendRebootCommandRequest",
  () => [
    { no: 1, name: "serial_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.SendRebootCommandResponse
 */
export const SendRebootCommandResponse = proto3.makeMessageType(
  "msh.service.v1.SendRebootCommandResponse",
  [],
);

/**
 * @generated from message msh.service.v1.SendConfirmFallCommandRequest
 */
export const SendConfirmFallCommandRequest = proto3.makeMessageType(
  "msh.service.v1.SendConfirmFallCommandRequest",
  () => [
    { no: 1, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "fall_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.SendConfirmFallCommandResponse
 */
export const SendConfirmFallCommandResponse = proto3.makeMessageType(
  "msh.service.v1.SendConfirmFallCommandResponse",
  () => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(SendConfirmFallCommandResponse_ConfirmFallResponse) },
    { no: 2, name: "details", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from enum msh.service.v1.SendConfirmFallCommandResponse.ConfirmFallResponse
 */
export const SendConfirmFallCommandResponse_ConfirmFallResponse = proto3.makeEnum(
  "msh.service.v1.SendConfirmFallCommandResponse.ConfirmFallResponse",
  [
    {no: 0, name: "CONFIRM_FALL_RESPONSE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CONFIRM_FALL_RESPONSE_SUCCESS", localName: "SUCCESS"},
    {no: 2, name: "CONFIRM_FALL_RESPONSE_ERROR", localName: "ERROR"},
    {no: 3, name: "CONFIRM_FALL_RESPONSE_ERROR_NO_DEVICE_IN_DATASTORE", localName: "ERROR_NO_DEVICE_IN_DATASTORE"},
    {no: 4, name: "CONFIRM_FALL_RESPONSE_ERROR_NO_DEVICE_IN_IOT", localName: "ERROR_NO_DEVICE_IN_IOT"},
  ],
);

/**
 * @generated from message msh.service.v1.SendStartRecordingDeviceCommandRequest
 */
export const SendStartRecordingDeviceCommandRequest = proto3.makeMessageType(
  "msh.service.v1.SendStartRecordingDeviceCommandRequest",
  () => [
    { no: 1, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "duration", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user_tag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.SendStartRecordingDeviceCommandResponse
 */
export const SendStartRecordingDeviceCommandResponse = proto3.makeMessageType(
  "msh.service.v1.SendStartRecordingDeviceCommandResponse",
  () => [
    { no: 1, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "message", T: IOTCoreCommandStatus },
  ],
);

/**
 * @generated from message msh.service.v1.SendStartGroupRecordingDeviceCommandRequest
 */
export const SendStartGroupRecordingDeviceCommandRequest = proto3.makeMessageType(
  "msh.service.v1.SendStartGroupRecordingDeviceCommandRequest",
  () => [
    { no: 1, name: "device_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "duration", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user_tag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.SendStartGroupRecordingDeviceCommandResponse
 */
export const SendStartGroupRecordingDeviceCommandResponse = proto3.makeMessageType(
  "msh.service.v1.SendStartGroupRecordingDeviceCommandResponse",
  () => [
    { no: 1, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "device_start_responses", kind: "message", T: DeviceStartGroupResponse, repeated: true },
  ],
);

/**
 * @generated from message msh.service.v1.DeviceStartGroupResponse
 */
export const DeviceStartGroupResponse = proto3.makeMessageType(
  "msh.service.v1.DeviceStartGroupResponse",
  () => [
    { no: 1, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "message", T: IOTCoreCommandStatus },
  ],
);

/**
 * @generated from message msh.service.v1.SendStopRecordingDeviceCommandRequest
 */
export const SendStopRecordingDeviceCommandRequest = proto3.makeMessageType(
  "msh.service.v1.SendStopRecordingDeviceCommandRequest",
  () => [
    { no: 1, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.SendStopRecordingDeviceCommandResponse
 */
export const SendStopRecordingDeviceCommandResponse = proto3.makeMessageType(
  "msh.service.v1.SendStopRecordingDeviceCommandResponse",
  () => [
    { no: 1, name: "status", kind: "message", T: IOTCoreCommandStatus },
  ],
);

/**
 * @generated from message msh.service.v1.SendCancelRecordingDeviceCommandRequest
 */
export const SendCancelRecordingDeviceCommandRequest = proto3.makeMessageType(
  "msh.service.v1.SendCancelRecordingDeviceCommandRequest",
  () => [
    { no: 1, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.SendCancelRecordingDeviceCommandResponse
 */
export const SendCancelRecordingDeviceCommandResponse = proto3.makeMessageType(
  "msh.service.v1.SendCancelRecordingDeviceCommandResponse",
  () => [
    { no: 1, name: "status", kind: "message", T: IOTCoreCommandStatus },
  ],
);

/**
 * @generated from message msh.service.v1.GetADLDeviceEventsRequest
 */
export const GetADLDeviceEventsRequest = proto3.makeMessageType(
  "msh.service.v1.GetADLDeviceEventsRequest",
  () => [
    { no: 1, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "filter", kind: "message", T: EventFilter },
    { no: 3, name: "page", kind: "message", T: Page },
  ],
);

/**
 * @generated from message msh.service.v1.GetADLDeviceEventsResponse
 */
export const GetADLDeviceEventsResponse = proto3.makeMessageType(
  "msh.service.v1.GetADLDeviceEventsResponse",
  () => [
    { no: 1, name: "events", kind: "message", T: Event, repeated: true },
    { no: 2, name: "page", kind: "message", T: Page },
  ],
);

/**
 * @generated from message msh.service.v1.GetDeviceActivityLevelHistoryRequest
 */
export const GetDeviceActivityLevelHistoryRequest = proto3.makeMessageType(
  "msh.service.v1.GetDeviceActivityLevelHistoryRequest",
  () => [
    { no: 1, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "timestamp", kind: "message", T: Timestamp },
    { no: 3, name: "time_frame", kind: "enum", T: proto3.getEnumType(TimeFrame) },
  ],
);

/**
 * @generated from message msh.service.v1.GetDeviceActivityLevelHistoryResponse
 */
export const GetDeviceActivityLevelHistoryResponse = proto3.makeMessageType(
  "msh.service.v1.GetDeviceActivityLevelHistoryResponse",
  () => [
    { no: 1, name: "activities", kind: "message", T: GetDeviceActivityLevelHistoryResponse_ActivityHistory, repeated: true },
  ],
);

/**
 * @generated from message msh.service.v1.GetDeviceActivityLevelHistoryResponse.ActivityHistory
 */
export const GetDeviceActivityLevelHistoryResponse_ActivityHistory = proto3.makeMessageType(
  "msh.service.v1.GetDeviceActivityLevelHistoryResponse.ActivityHistory",
  () => [
    { no: 1, name: "timestamp", kind: "message", T: Timestamp },
    { no: 2, name: "activity_level", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "GetDeviceActivityLevelHistoryResponse_ActivityHistory"},
);

/**
 * @generated from message msh.service.v1.GetDeviceByProductNameRequest
 */
export const GetDeviceByProductNameRequest = proto3.makeMessageType(
  "msh.service.v1.GetDeviceByProductNameRequest",
  () => [
    { no: 1, name: "product_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.service.v1.GetDeviceByProductNameResponse
 */
export const GetDeviceByProductNameResponse = proto3.makeMessageType(
  "msh.service.v1.GetDeviceByProductNameResponse",
  () => [
    { no: 1, name: "device", kind: "message", T: Device },
  ],
);

